function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 24v33.58l23.87-27.49A49.82 49.82 0 007 24z",
  fill: "#343741",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 0v24a49.82 49.82 0 0123.87 6.09L57 0z",
  fill: "#f04e98",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.315 33.31l-24.47 28.2L8.685 64h46.63a50 50 0 00-20-30.69z",
  fill: "#00bfb3",
  fillRule: "evenodd"
});

function SvgKibana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PHBhdGggZD0iTTcgMjR2MzMuNThsMjMuODctMjcuNDlBNDkuODIgNDkuODIgMCAwIDAgNyAyNHoiIGZpbGw9IiMzNDM3NDEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik03IDB2MjRhNDkuODIgNDkuODIgMCAwIDEgMjMuODcgNi4wOUw1NyAweiIgZmlsbD0iI2YwNGU5OCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PHBhdGggZD0iTTM1LjMxNSAzMy4zMWwtMjQuNDcgMjguMkw4LjY4NSA2NGg0Ni42M2E1MCA1MCAwIDAgMC0yMC0zMC42OXoiIGZpbGw9IiMwMGJmYjMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPgo=";
export { SvgKibana as ReactComponent };